import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-collection",
  "use": "icon-icon-collection-usage",
  "viewBox": "0 0 13 11.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 13 11.3\" id=\"icon-icon-collection\">\r\n<title>资源 6</title>\r\n<g id=\"icon-icon-collection_图层_2_1_\">\r\n\t<g id=\"icon-icon-collection_图层_1-2\">\r\n\t\t<g>\r\n\t\t\t<path d=\"M6.5,11.3c-0.3,0-0.5-0.1-0.8-0.2l-2-1.6C3.4,9.3,3.1,9.1,2.8,8.9C1.5,8,0,7,0,4.1c0-1.9,1.1-3.5,2.8-4\r\n\t\t\t\tc1.3-0.4,2.7,0,3.7,1.1c0.9-0.9,2-1.2,3.3-0.8C11.5,0.9,13,2.6,13,4.1c0,2.4-2.1,4.1-3.7,5.4l-2,1.6C7.1,11.3,6.8,11.3,6.5,11.3z\r\n\t\t\t\t M3.9,1C3.6,1,3.4,1,3.1,1.1C2.1,1.4,1,2.5,1,4.1C1,6.5,2.1,7.2,3.3,8c0.3,0.2,0.7,0.4,1,0.7l2,1.6c0.1,0.1,0.3,0.1,0.4,0l2-1.6\r\n\t\t\t\tC10.2,7.5,12,6.1,12,4.1c0-1.1-1.2-2.4-2.5-2.8C8.8,1.1,7.7,1.1,6.9,2.3c-0.2,0.3-0.6,0.3-0.8,0C5.5,1.4,4.7,1,3.9,1z\" />\r\n\t\t</g>\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-collection.svg
// module id = GV9i
// module chunks = 72